import React, { useEffect, useState } from "react";
import Tagadd from "../../components/Tag/tag-add/Tagadd";
import "./user.scss";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";
import AutoComplete from "rsuite/AutoComplete";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";

function Users() {
  const [data, setData] = useState([]);
  const [search, setsearch] = useState(false);
  const [autoComplete, setAutoComplete] = useState([]);

  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [idStaff, setIdStaff] = useState();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/staff");
    const name = result.data.data.map((value) => value.name);
    const email = result.data.data.map((value) => value.email);
    setAutoComplete(name.concat(email));
    setData(result.data.data);
    setGetSuccess(true);
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const deleteStaff = async (id) => {
    setIdStaff(id);
    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    await axios.delete(`https://mobile.amospa.com/staff/${idStaff}`);
    setModalShow(false);
    window.location.reload();
  };

  useEffect(() => {
    getData();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, getSuccess]);

  //Handle search
  const keys = ["name", "email"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const user = handleSearch();
  const dataTable = user ? user : currentItems;

  return (
    <div className="staff">
      <div className="staff-search-header py-4">
        <span className="d-flex align-items-center text-white ms-2">
          <h3>List Of Staff</h3>
          <p className="staff-show ms-2">
            <select
              onChange={(e) => setitemsPerPage(e.target.value)}
              className="text-dark"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </p>
        </span>
        <span className="d-flex">
          <Link to={"/homepage/staff-add"}>
            <button
              className="btn rounded-3 me-2 fw-bold"
              style={{ background: "#FFD700" }}
            >
              ADD STAFF
            </button>
          </Link>
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoComplete}
            />
          </span>
        </span>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>NO</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Photo</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dataTable.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.name}</td>
              <td>{item.email}</td>
              <td>{item.phone}</td>
              <td>
                <img src={item.image} alt="" />
              </td>
              <td>
                <Link to={`/homepage/staff/id-card/${item.name}/${item.id}`}>
                  <button
                    className="btn-staffid m-1 py-1 bg-warning text-dark"
                    style={{ width: "100px", borderRadius: "10px" }}
                  >
                    Details
                  </button>
                </Link>
                <Link to={`/homepage/staff-edit/${item.id}`}>
                  <button
                    className="btn-staffid m-1 py-1 bg-warning text-dark"
                    style={{ width: "100px", borderRadius: "10px" }}
                  >
                    Edit
                  </button>
                </Link>
                <button
                  className="btn-staffid m-1 py-1 bg-danger"
                  style={{ width: "100px", borderRadius: "10px" }}
                  onClick={() => deleteStaff(item.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="footer-member-list my-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-member-list-rigth me-1">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Delete Staff ?"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Users;
